import { space, colors, Box } from '@workday/canvas-kit-react'
import React from 'react'
import IncidentCard from './IncidentCard'
import TimeDisplayOption from '../models/TimeDisplayOptions'
import { IncidentModel } from '../../models/IncidentModel'
import { AgencyModel } from '../../models/AgencyModel'

export interface IncidentCardContainerProps {
  timeDisplayOption: TimeDisplayOption
  incident: IncidentModel
  agency: AgencyModel
  showAgencyTitle: boolean
}

const IncidentCardContainer = ({ timeDisplayOption, incident, agency, showAgencyTitle }: IncidentCardContainerProps) => {
  return (
    <Box padding={space.xs} borderBottom={`1px solid ${colors.soap600}`}>
      <IncidentCard incident={incident} showAgencyTitle={showAgencyTitle} agency={agency}  timeDisplayOption={timeDisplayOption} />
    </Box>
  )
}

export default IncidentCardContainer
